import { FilterButton } from 'ogp/components/views/administration/shared';
import { LwButton, Toolbox } from 'redesign';

type ShiftPlanningToolboxProps = {
  selectedShiftIds: string[];
  selectedFilterCount: number;
  toggleFilters: () => void;
  setIsBarSideBarOpen: (open: boolean) => void;
  setIsBulkArchiveBarOpen: (open: boolean) => void;
  setCreateWorkSidebarOpen: (open: boolean) => void;
};

export const ShiftPlanningToolbox = ({
  selectedShiftIds,
  selectedFilterCount,
  setIsBarSideBarOpen,
  setIsBulkArchiveBarOpen,
  setCreateWorkSidebarOpen,
  toggleFilters,
}: ShiftPlanningToolboxProps) => {
  return (
    <Toolbox underline={false}>
      <LwButton color="primary" onClick={() => setCreateWorkSidebarOpen(true)} iconColorMode="fill">
        Voeg shift toe
      </LwButton>

      <LwButton
        disabled={selectedShiftIds.length === 0}
        color="secondary"
        onClick={() => setIsBarSideBarOpen(true)}
        iconColorMode="fill"
      >
        Aanpassen{selectedShiftIds.length > 0 ? ` (${selectedShiftIds.length})` : ''}
      </LwButton>

      <LwButton
        disabled={selectedShiftIds.length === 0}
        color="secondary"
        onClick={() => setIsBulkArchiveBarOpen(true)}
        iconColorMode="fill"
      >
        Verwijderen{selectedShiftIds.length > 0 ? ` (${selectedShiftIds.length})` : ''}
      </LwButton>

      <Toolbox.PushRight>
        <FilterButton onClick={toggleFilters} nrOfActiveFilters={selectedFilterCount} />
      </Toolbox.PushRight>
    </Toolbox>
  );
};
